module.exports = __webpack_public_path__ + "img/cat-2.beb6db56.svg";